/**
 *  11332上报专用库（H5平台业务上报库）
 *  @module report/11332
 *
 *  @alias module:report/11332.report
 *  @param {object} _o                        - 上报内容
 *  @param {number|string}  [_o.auth_type=1]  - 校验类型，默认是微信内的登录校验
 *  @param {number} [_o.iLogType=0]           - 上报页面的abt版本
 *  @param {number} [_o.iOpType=0]            - 用户操作类型上报位，pv曝光为1，其余用户操作都为2
 *  @param {number} [_o.iActionId=0]          - 用户动作类行上报位，pv曝光为1，其余看用户实际操作（跳转：40，下载游戏为22等等）
 *  @param {string} [_o.sGameId=0]            - 上报所涉及的游戏ID
 *  @param {number} [_o.iSceneId=0]           - 上报页面所属的场景id
 *  @param {number} [_o.iUIArea=0]            - 上报信息所在的UIArea的id
 *  @param {number} [_o.iPositionId=0]        - 上报信息所在的PositionId
 *  @param {string} [_o.sExternInfo='']       - 上报的额外信息字段，一般需要encodeURIComponent以后进行上报
 *
 *  @example 
 *  var report11332 = require('../report/11332');
 *  report11332.report({
 *      iSceneId: 24,
 *      iUIArea: 2438,
 *      iPostionId: 101,
 *      sGameId: 'wx3ef156df1234',
 *      sExternInfo: encodeURIComponent(
 *                      JSON.stringify( {is_game_user: 1})
 *                  )
 *  });
 */

import mweixin from '../report/report_base.js';

import * as base from '../base/mbase.js';
import env from '../common/env.js';
import wxBridge from '../jsbridge/jsbridge_login_queue.js';
import * as str from '../base/string.js';
var getQueryStr = base.getQueryStr;

import msdk from '../common/msdkLogin.js';
import checkErr from './11332_check_error.js';
import calExpID from './11332_cal_expid.js';
import Dom from '../base/mdom.js';
let exportData;
if(!env.isCSR) {
    var top         = Dom.window;
    (function (_aoExport, win, doc) {
        "use strict";
          if( win.WXGAME?.Report11332?.report ) {
            _aoExport.report = win.WXGAME.Report11332.report.bind(win.WXGAME.Report11332)
            exportData = _aoExport;
            return
          }

            function getCommonParamUrl(_sUrl, _o){

                /**
                 * 这两个参数，已删除。全部改为由后台来获取。
                 */
                // _sUrl += "&Device=" + (_o.sDevice || (_reportObj.device == 'iphone' ? 1 : 2) || 0);
                // _sUrl += "&ClientVersion=" + (_o.sClientVersion || _reportObj.clientversion || 0);


                _sUrl += "&ActID="          + (_o.iActID 
                                                || _reportObj.actid 
                                                || 0);
                _sUrl += "&LogType="        + (_o.iLogType 
                                                || _reportObj.iLogType 
                                                || getQueryStr('abt') 
                                                || 0);

                _sUrl += "&SceneID="        + (_o.iSceneId || 0);
                _sUrl += "&GameID="         + (_o.sGameId || "");
                let ssid = _o.iSourceSceneId || getQueryStr('ssid',null,top) || 0;
                let sourceid = _o.iSourceId || getQueryStr('source_id',null,top) || 0;
                if( sourceid ) { // 优先取sourceid
                    // 对sourceid做个格式校验，防止类型不对导致整条数据无效
                    if( /^\d+$/.test(sourceid) ) {
                        _sUrl += "&SourceID=" + sourceid;
                    }
                }else if( ssid ) {  // 无sourceid，再取ssid, 对旧数据做兼容逻辑
                    // 对ssid做个格式校验，防止类型不对导致整条数据无效
                    if( /^\d+$/.test(ssid) ) { 
                        _sUrl += "&SourceID=" + ssid;
                    }
                }
                // ssid 取 [0, 100] 之间的
                if( ssid >= 0 && ssid <= 100) {
                    _sUrl += "&ssid=" + ssid;
                }

                let time = _o.iTime;
                // 对time做一个数字类型保护
                if( time ) {
                    time = Number(time)
                    if( time !== time ) { // 如果是NaN的话，强制设置为0
                        time = 0
                    }else { // 强制做一下取整，避免小数
                        time = Math.floor(time)
                    }
                }

                _sUrl += "&UIArea="         + (_o.iUIArea       || 0);
                _sUrl += "&PositionID="     + (_o.iPositionId   || 0);
                _sUrl += "&ActionID="       + (_o.iActionId     || 0);
                _sUrl += "&ActionStatus="   + (_o.sActionStatus || "");
                _sUrl += "&GiftID="         + (_o.iGiftBagId    || 0);
                _sUrl += "&GiftType="       + (_o.iGiftBagType  || 0);
                _sUrl += "&ChatroomName="   + (_o.iChatroomName  || "");
                _sUrl += "&NoticeID="       + (_o.iNoticeId  || getQueryStr('noticeid',null,top) || 0);

                _sUrl += "&ConnectType="    + (_o.sConnectType 
                                                || _reportObj.networktype 
                                                || "");
                _sUrl += "&ISP="            + (_o.sServiceProvider  || '');
                _sUrl += "&DeviceBrand="    + (_o.sDeviceBrand      || '');
                _sUrl += "&DeviceModel="    + (_o.sDeviceModel      || '');

                _sUrl += "&OpType="         + (_o.iOpType           || 0);

                var expObj = calExpID(_o);
                _sUrl += '&ExpID='          + (_o.iExpID            || expObj.exp_id    || 0);
                _sUrl += '&ReasonID='       + (_o.iReasonID         || expObj.reason_id || 0);
                
                _sUrl += "&allpath="        + (getQueryStr('rpt_allpath') || "");
                
                _sUrl += '&getType='        + (env.isWepkg() ? 1 : 2);

                _sUrl += '&URL='            + encodeURIComponent(location.href.split("#")[0]
                                                .replace(/&(uin|pass_ticket|key)=[^&]+/g, '')
                                                .replace(/\?(uin|pass_ticket|key)=[^&]+/g, '?'));

                _sUrl += "&ExternInfo="     + str.exencodeURIComponent(_o.sExternInfo 
                                                || _reportObj.sExternInfo 
                                                || "");
                
                // add by zijian ，上报数据错误自查
                _sUrl += '&errType='        + checkErr(_o);

                // 新增字段 ContentType Time VideoID ExpID ReasonID
                // tapd: http://tapd.oa.com/10079491/prong/stories/view/1010079491064596219
                if(_o.iContentType)  _sUrl += '&ContentType='    + (_o.iContentType  || 0);
                if(time)         _sUrl += '&Time='           + (time         || 0);
                if(_o.sVideoID)      _sUrl += '&VideoID='        + (_o.sVideoID      || "");
                // if(_o.iExpID)        _sUrl += '&ExpID='          + (_o.iExpID        || calExpID(_o) || 0);
                // if(_o.iReasonID)     _sUrl += '&ReasonID='       + (_o.iReasonID     || 0);
                // 用户行为发生时的时间戳
                _sUrl += '&client_timestamp=' + Date.now();
                if(window.__KULP_BUILD_VERSION__) {
                    _sUrl += '&BuildVersion=' + (window.__KULP_BUILD_VERSION__ || "");
                }      
        
                _sUrl += '&t='              + (new Date().getTime());
                return _sUrl;      
            }
        
            function  extendExternInfo(obj) {
                var rpt_ssid_str = getQueryStr('rpt_ssid_str') || '';
                var from_id = getQueryStr('from_id');
                var currentPkgid = getQueryStr('wechat_pkgid') || '';
                var fromPkgid = getQueryStr('from_wechat_pkgid') || '';
                var sProt = getQueryStr('s_prot');
                var sUia = getQueryStr('s_uia');
                var sPid = getQueryStr('s_pid')
                var sCid = getQueryStr('s_cid')
                var sCtype = getQueryStr('s_ctype');
                var shareId = getQueryStr('share_id');
                var originShareId = getQueryStr("origin_share_id");
                var externinfo = obj.sExternInfo;
                var globalExternInfo = {}
                if (rpt_ssid_str) {
                  globalExternInfo.rpt_ssid_str = rpt_ssid_str;
                }
                if (from_id && /^\d+$/.test(from_id)) {
                    globalExternInfo.from_id = Number(from_id);
                }

                globalExternInfo.pkgid = currentPkgid;
                globalExternInfo.from_pkgid = fromPkgid;
                // 透传其他协议信息
                if( sProt && /^\d+$/.test(sProt)) {
                    globalExternInfo.s_prot = Number(sProt);
                }
                if( sUia && /^\d+$/.test(sUia)) {
                    globalExternInfo.s_uia = Number(sUia);
                }
                if( sPid && /^\d+$/.test(sPid)) {
                    globalExternInfo.s_pid = Number(sPid);
                }
                if( sCid ) {
                    globalExternInfo.s_cid = sCid;
                }
                if( sCtype ) {
                    globalExternInfo.s_ctype = sCtype;
                }

                // 上报分享来源
                if( shareId ) {
                    globalExternInfo.share_id = shareId
                }
                if( originShareId ) {
                    globalExternInfo.origin_share_id = originShareId
                }
        
                try {
                    if (Object.keys(globalExternInfo).length === 0) return obj;
        
                    if(!externinfo) {
                        externinfo = JSON.stringify(globalExternInfo);
                    } else {
                        if (typeof externinfo === 'string') {
        
                          var externinfo_obj = JSON.parse(decodeURIComponent(externinfo));
                            externinfo_obj      = base.extend(
                                    globalExternInfo, 
                                    externinfo_obj
                                );
                            externinfo          = JSON.stringify(externinfo_obj);
        
                        } else if (typeof externinfo === 'object') {
        
                            externinfo = JSON.stringify(
                                    base.extend(
                                        globalExternInfo, 
                                        externinfo
                                    )
                            );
        
                        }
                    }
                    /**
                     * externinfo这个变量，是个字符串了。
                     */
                    obj.sExternInfo = (externinfo);
        
                    return obj;
                } catch (e) {
                    return obj;
                }
            }
        
            function getLoginParamsStrByLoginType(){
                var msdkLogin = msdk.getMsdkLogin();
                msdkLogin.auth_type = 2;
                return str.mapToStr(msdkLogin);
            }
            //上报类型中的device必须是字符串，
            //iphone,android-lite-,android,symbian60v3,symbian60v5,
            //wp7,webwx,blackberry-,wp8,s40asha v5,s40asha,BlackBerry10-,其他字符串
            var _reportObj = _aoExport.reportObj;
            //11332 平台类上报
            function report11332(_o) {
                _o = _o || {};
        
                /*
                *   支持由参数传auth_type。不传为2，则会是微信平台级的上报。
                */
                var isInWx = env.isWechat || env.isPcWechat;
                
                //_o.auth_type+'' == '2' || getQueryStr('auth_type') == '2';
        
                var _sUrl =  isInWx ?
                            "//game.weixin.qq.com/cgi-bin/comm/cltstat?" : 
                            '//game.weixin.qq.com/cgi-bin/groupwap/reportstat?';
                
        
                if( isInWx || getQueryStr("uin",null,top)){
                    wxBridge.getUinKey(function(login){
                        _sUrl += "uin="  + (decodeURIComponent( login.uin ) || _o.uin);
                        _sUrl += "&key=" + ( login.key || _o.key  );
                        _sUrl += "&pass_ticket=" + (_o.pass_ticket || login.pass_ticket);
                        let gameSessionId = env.getGameSessionId();
                        if( gameSessionId ) {
                            _sUrl += `&x-wxgame-session=${encodeURIComponent(gameSessionId)}`;
                        }
                        
                        _o      = extendExternInfo(_o);
                        _sUrl   = getCommonParamUrl(_sUrl, _o);
                        _sUrl   = str.filterUrlByKey(_sUrl, ['uin', 'key']);
                        _aoExport.imgReport(_sUrl);
                    });
                    
                }else{
                    _sUrl  += getLoginParamsStrByLoginType();
                    
                    _o      = extendExternInfo(_o);
                    _sUrl   = getCommonParamUrl(_sUrl, _o);
                    _sUrl   = str.filterUrlByKey(_sUrl, ['uin', 'key']);
                    _aoExport.imgReport(_sUrl);
                }
            }

        _aoExport.report = report11332;
        exportData =  _aoExport;
    })(base.extend({}, mweixin), window, document);
}else{
    exportData = {};
}
export default exportData;
